import API from '@aws-amplify/api'
import { createAsyncThunk } from '@reduxjs/toolkit'
import camelcaseKeys from 'camelcase-keys'
import snakecaseKeys from 'snakecase-keys'

export const makeApi = method => async (path, myInit = {}) => {
  // Transform case of queryStringParameters and body to snake_case
  const transformKeys = ['queryStringParameters', 'body']
  const transformedInit = {
    ...myInit,
    ...transformKeys.reduce((acc, key) => {
      const toTransform = myInit[key]
      if (toTransform) {
        acc[key] = snakecaseKeys(toTransform, { deep: true })
      }
      return acc
    }, {}),
  }

  // Transform case of response to camelCase
  try {
    const result = await API[method]('default', path, transformedInit)
    const transformed = camelcaseKeys(result, { deep: true })
    return transformed
  } catch (error) {
    if (error.response) {
      error.response.data = camelcaseKeys(error.response.data, { deep: true })
    }
    throw error
  }
}

export const get = makeApi('get')
export const post = makeApi('post')
export const patch = makeApi('patch')
export const put = makeApi('put')
export const del = makeApi('del')

const api = {
  get,
  post,
  patch,
  put,
  del,
}

// Wraps createAsyncThunk to handle api error responses with a payload
export const createWrappedAsyncThunk = (type, payloadCreator) =>
  createAsyncThunk(type, async (arg, thunkApi) => {
    const { rejectWithValue } = thunkApi
    try {
      return await payloadCreator(arg, thunkApi)
    } catch (error) {
      if (!error.response) {
        throw error
      }
      throw rejectWithValue({
        status: error.response.status,
        data: error.response.data,
      })
    }
  })

export default api
